












































import { biHT } from "@/business/bi";
import { CouponItemExtend, isLongAmount } from "@/business/couponList";
import { language } from "@tencent/ppd-base-libs";
import { Component, Prop, Vue } from "vue-property-decorator";
import { parseHK$Aria, CouponAmount } from "@tencent/wphk-act-base-ui";
@Component({
  components: {
    CouponAmount,
  },
})
export default class CouponItem extends Vue {
  @Prop({ required: true }) public coupon?: CouponItemExtend;
  @Prop({ required: true }) public isInvalidCoupon?: boolean;
  parseHK$Aria = parseHK$Aria;
  public created() {
    console.log("couponItem", this.coupon);
  }
  private get lang() {
    return language.getLang();
  }
  private get smallAmountClass() {
    return isLongAmount(this.coupon?.discount) && "small";
  }
  private get isShowStatusTag() {
    return this.coupon?.couponTagText && !this.isInvalidCoupon;
  }
  private goToDetail() {
    this.$router.push({
      name: "couponDetail",
      query: { user_coupon_id: this.coupon?.userCouponId, from: "couponList" },
    });
    // biHT
    const hotTagText = this.isInvalidCoupon
      ? "wallet.couponlist.expiredpage.coupon_click"
      : "wallet.couponlist.listpage.coupon_click";
    biHT(hotTagText, { fcouponname: this.coupon?.couponName });
  }
}
